/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TclItsmUserAttributeEncryption {
    getFixupPrototypeFunction() { return TclItsmUserAttributeEncryption.fixupPrototype; }

    static newInstance(model: Partial<TclItsmUserAttributeEncryption>): TclItsmUserAttributeEncryption {
        let obj = Object.assign(new TclItsmUserAttributeEncryption(), model);
        TclItsmUserAttributeEncryption.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TclItsmUserAttributeEncryption>): TclItsmUserAttributeEncryption {
        if (!model) return null;
        return TclItsmUserAttributeEncryption.newInstance(<TclItsmUserAttributeEncryption> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TclItsmUserAttributeEncryption) {
        if (!obj) return;

        models.TclItsmUserAttributeEncryption.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TclItsmUserAttributeEncryption): boolean {
        Object.setPrototypeOf(obj, TclItsmUserAttributeEncryption.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Allowed values for TCL ITSM User Actions
     */
    action: models.TclItsmUserAction;

    /**
     * Selected attributes for encryption
     */
    selected_attributes: Array<string>;

}
